import React from "react";
import PageWrapper from "../../components/UI/PageWrapper";
import ProfileSectionedArtistProfile from "../../components/Profile/ProfileSectionedArtistProfile";

const ProfileArtistInformationPage: React.FC = () => {
  return (
    <PageWrapper>
      <ProfileSectionedArtistProfile activeSection="artist" />
    </PageWrapper>
  );
};

export default ProfileArtistInformationPage;

